/* eslint-disable arrow-body-style */
import * as React from "react";
import {Component } from "react";

import "./process-logs.scss";

import {observer} from "mobx-react";
import {ProcessStatusConfiguration} from "../../config/process-status-configuration";
import {List, ListDescription, ListHeader, ListItem} from "semantic-ui-react";
import {ProcessLog} from "../../models/process-log";
import {MapViewerConfiguration} from "../../config/map-viewer-configuration";
import {Icon} from "../../core/components/icon/icon";
import moment from "moment";

export interface ProcessLogsProps {
    logs: ProcessLog[];
    status: ProcessStatusConfiguration;
    mapViewerConfig: MapViewerConfiguration;
}

@observer
export class ProcessLogs extends Component<ProcessLogsProps, any> {

    constructor(props: ProcessLogsProps) {
        super(props);
        this.state = {
            error: null
        };
    }

    render(): React.ReactElement | null {
        const {logs, status} = this.props;

        const relevantLogs = logs.filter((log) => {
            return log.statusTo === status.id;
        });
        const sortedLogs = relevantLogs.sort(ProcessLog.sortByDate).reverse();

        // TODO: group by cycle. insert ListItem with class 'log-item divider' before each new cycle
        const groupedLogs = this.groupLogsBy(sortedLogs, "cycle");

        const logGroups: React.React.ReactElement[] = [];
        Object.entries(groupedLogs).forEach((entry) => {
            const group = entry[0]; // group is a datetime string qe.g. 20240130_1754
            const groupDate = group === "1" ? null : moment(group, "YYYYMMDD_HHmm");
            const groupLogs = entry[1];
            const listItems = groupLogs.map((log) => {
                const editor = this.formatEditor(log.editor);
                const timestamp = new Intl.DateTimeFormat("de-CH",
                    {
                        year: "numeric", month: "2-digit", day: "2-digit",
                        hour: "2-digit", minute: "2-digit"
                    }).format(log.timeStamp);
                return (
                    <ListItem size="mini" key={`log-item-${log.objectId}`}
                        className={`log-item log-level-${log.type} cycle-${log.cycle || 1}`}>
                        <ListHeader className="process-log-message">{log.message}</ListHeader>
                        <ListDescription>
                            <span className="process-log-timestamp">{timestamp}</span>:
                            <span className="process-log-editor">{editor}</span>
                        </ListDescription>
                    </ListItem>
                );
            });
            if (groupDate) {
                // add group divider
                logGroups.push(
                    <ListItem className="log-item divider" key={`${group}-divider-${crypto.randomUUID()}`}>
                        Upload vom {moment(groupDate).format("DD.MM.YYYY, HH:mm")}
                    </ListItem>
                );
            }
            logGroups.push(...listItems);
        });

        return (
            <List className="process-logs" key={`logs-status-${status.id}`}>
                {logGroups}
            </List>
        );
    }

    private formatEditor(editor: string): string | React.ReactElement {
        const {mapViewerConfig} = this.props;

        const mapping = mapViewerConfig.processLog.userMappings.find((m) => {
            return m.userName === editor;
        });
        if (!mapping) {
            return editor;
        }
        if (mapping.icon && mapping.displayName) {
            return (
                <>
                    <Icon name={mapping.icon} />{mapping.displayName}
                </>
            );
        }
        if (mapping.icon) {
            return <Icon name={mapping.icon} />;
        }
        return mapping.displayName || editor;
    }

    private groupLogsBy<T>(array: T[], key: string): Record<string, T[]> {
        return array.reduce((rv, x) => {
            const group = x[key] || "1";
            (rv[group] = rv[group] || []).push(x);
            return rv;
        }, {});
    }
}
